import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  output,
  signal,
} from '@angular/core';

import { AdminSubscriptionFormComponent } from '../admin-subscription-form/admin-subscription-form.component';
import { Guid, Nillable } from '@web/utils';
import {
  AlertsComponent,
  AlertsService,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { AdminSubscriptionDataSourceService } from '../../services';
import { AdminSubscriptionForm } from '../../models/admin-subscription-form';
import { HttpErrorService } from '@web/common';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-admin-subscription-edit',
  imports: [
    AdminSubscriptionFormComponent,
    SpinnerFilledComponent,
    AlertsComponent,
  ],
  templateUrl: './admin-subscription-edit.component.html',
  styleUrl: './admin-subscription-edit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminSubscriptionEditComponent implements OnInit {
  public readonly id = input.required<Guid>();
  public readonly submitEvent = output<void>();

  protected readonly data = signal<Nillable<AdminSubscriptionForm>>(null);

  /* prettier-ignore */
  private readonly subscriptionDataSource = inject(AdminSubscriptionDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public ngOnInit(): void {
    this.subscriptionDataSource
      .fetchFormById(this.id())
      .subscribe((data) => this.data.set(data));
  }

  public handleSubmitClickEvent(data: AdminSubscriptionForm): void {
    this.subscriptionDataSource
      .updateSubscriptionByForm({
        id: this.id(),
        data,
      })
      .subscribe({
        next: () => this.submitEvent.emit(),
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }
}
